import { render, staticRenderFns } from "./DataExport.vue?vue&type=template&id=24938566&scoped=true"
import script from "./DataExport.vue?vue&type=script&lang=js"
export * from "./DataExport.vue?vue&type=script&lang=js"
import style0 from "./DataExport.vue?vue&type=style&index=0&id=24938566&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24938566",
  null
  
)

export default component.exports